/** Aynı URL’deki logo/görsel güncellemelerinde tarayıcı önbelleğini kırmak için. */
export function withCacheBust(url: string | null | undefined, version?: string | null): string | null {
  if (!url?.trim()) return null;
  const base = url.trim();
  const ts = version ? new Date(version).getTime() : 0;
  if (!ts || Number.isNaN(ts)) return base;
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}v=${ts}`;
}
